import styled from '@emotion/styled'

export const RadioButtonWrapper = styled.div`
  margin: 5px 0 14px;
  display: flex;
  flex-direction: row;

  @media (max-width: 768px) {
    margin: 5px 0 10px;
  }
`

export const RadioGroupWrapper = styled.div`
  display: flex;

  &.row {
    flex-direction: row;
  }

  &.column {
    flex-direction: column;
  }
`
